import { useState } from "react";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, apiError, setToken } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

/** On My profile: change the password at any time. */
export const ChangePassword = () => {
  const [current, setCurrent] = useState("");
  const [pw, setPw] = useState("");
  const [again, setAgain] = useState("");
  const [busy, setBusy] = useState(false);
  const { user, refresh } = useAuth();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/change-password", {
        current_password: current,
        new_password: pw,
      });
      if (data.token) setToken(data.token);
      await refresh();
      setCurrent("");
      setPw("");
      setAgain("");
      toast.success("Your password has been changed.");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mt-8 border border-border bg-card p-5" data-testid="change-password-panel">
      <div className="flex items-center gap-2">
        <KeyRound className="h-4 w-4 text-primary" />
        <div className="label-caps">Your password</div>
      </div>
      <p className="mt-2 max-w-2xl text-sm text-muted-foreground">
        You can sign in either with a 6-digit passcode or with a password. Both stay open.
        {user?.password_is_default
          ? " You are still on the password the portal gave you — please set your own."
          : ""}
      </p>
      <form onSubmit={submit} className="mt-4 grid gap-3 sm:grid-cols-3">
        <Input
          type="password"
          className="h-11 rounded-none"
          data-testid="current-password-input"
          placeholder="Your current password"
          required
          value={current}
          onChange={(e) => setCurrent(e.target.value)}
        />
        <Input
          type="password"
          className="h-11 rounded-none"
          data-testid="profile-new-password-input"
          placeholder="New password (8+ characters)"
          required
          value={pw}
          onChange={(e) => setPw(e.target.value)}
        />
        <Input
          type="password"
          className="h-11 rounded-none"
          data-testid="profile-confirm-password-input"
          placeholder="Type it once more"
          required
          value={again}
          onChange={(e) => setAgain(e.target.value)}
        />
        <Button
          type="submit"
          disabled={busy || pw.length < 8 || pw !== again || !current}
          data-testid="change-password-button"
          className="h-11 rounded-none font-display text-xs font-bold uppercase tracking-widest sm:col-span-1"
        >
          {busy ? "Saving…" : "Change my password"}
        </Button>
      </form>
    </div>
  );
};
